import { Hsn } from "app/modules/masters/hsn-code/model/hsn.model";

export interface HsnState {
  hsn : Hsn [];
  loading: boolean;
  error: string | null;
}

export const initialHsnState: HsnState = {
  hsn: [],
  loading: false,
  error: null,
};
